import { isDate } from 'date-fns';
/** Returns true if `value` is an array of valid dates. */
export function isArrayOfDates(value) {
    return Array.isArray(value) && value.every(isDate);
}
//# sourceMappingURL=isArrayOfDates.js.map